import { Formio } from 'formiojs';
import editForm from './form';

const TextField = Formio.Components.components.textfield;

export default class Sum extends TextField {

    constructor(component, options, data) {
        super(component, options, data);
        this.checks = [];
    }

    static schema() {
        return TextField.schema({
            type: 'sum',
            label: 'Sum',
            key: 'sum',
            disabled: true,
        });
    }

    init() {
        this.on('change', (event) => {
            if (event.changed && event.changed.component.key === "sumComponents" ) {
                let selectedValues = event.changed.value;

                let json = {
                    "+": []
                }

                if (Array.isArray(selectedValues)) {
                    selectedValues.forEach(value => {
                        json["+"].push({"checkNumber": {var: value}}) // checkNumber is a rule defined in /formio/index.js
                    });
                }

                // When in doubt just manually overwrite values and hope you haven't dug too greedily and too deep
                // But for real, the change event we're interested in only fires when init() is scoped to defaultValue or sumComponents components
                // both of these components have the sum component instance as their parent, so we can set its calculateValue using the line below
                Formio.Utils.getComponent(this.parent.components, 'calculateValue').setValue(json);

                // Let folks know they can't see the value in the form builder but don't overwrite an existing placeholder... though why would they need one if sum is disabled?
                const placeholderComponent = Formio.Utils.getComponent(this.parent.components, 'placeholder');
                if (placeholderComponent.getValue() === "") {
                    placeholderComponent.setValue("Demo the form to see the calculated sum!");
                }
            }
        });
    }

    static builderInfo = {
        title: 'Sum',
        group: 'basic',
        icon: 'fa fa-table',
        weight: 70,
        documentation: '/userguide/#textfield',
        schema: Sum.schema()
    }

    static editForm = (...args) => {
        let updatedEditForm = editForm(...args);
        const components = JSON.parse(document.getElementById('definition').value).components
        const flattenedComponents = Formio.Utils.flattenComponents(components);

        const numbers = Object.entries(flattenedComponents)
            .filter(([name, component]) => component.type === 'number' || component.type === 'currency' || component.type === 'survey')
            .map(([name, component]) => {

                return {
                    label: component.label,
                    value: `data.${component.key}`
                }
            });

        const componentsToSumSelector = Formio.Utils.getComponent(updatedEditForm.components, 'sumComponents');
        componentsToSumSelector.data.values.push(...numbers);

        return updatedEditForm;
    };
}

// useful for testing
// console.log(jsonLogic.apply(
//     {
//         "+": [
//             {
//                 "checkNumber": {"var": "number1"}
//             },
//             {
//                 "checkNumber": {"var": "number2"}
//             }
//         ]
//     },
//     {number1: 6, number2: 4} // mock the data being sent into the json logic
// ));
